module.exports = __webpack_public_path__ + "static/img/img-2.1aacdb5f.png";